import React from 'react'
import sampleImg1 from '../../assets/images/PlayerScreen/myPic.jpg'
import sampleImg2 from '../../assets/images/PlayerScreen/myPic1.png'
import mute from '../../assets/images/PlayerWaiting/mute.svg'
import unmute from '../../assets/images/PlayerWaiting/unmute.svg'
import speak from '../../assets/images/PlayerWaiting/speak.svg'
import pak from '../../assets/images/PlayerScreen/pak.png'
import wait from '../../assets/images/PlayerWaiting/wait.png'
import '../../assets/css/style.scss'

const WaitingGroupCall = () => {

const groupCallData =[
    {
        id:0,
        name:"sufian",
        pic:'',
        pic1:pak,
        pic2:mute,
         pic3:unmute,
        background:"rgba(0, 0, 0, 0.5)"
    },
    {
        id:1,
        name:"host",
        pic:sampleImg1,
        // pic1:pak,
        pic2:mute,
         pic3:speak,
        background:"#D6A15E"
    },
    {
        id:2,
        name:"sufian",
        pic:sampleImg2,
        pic1:pak,
        pic2:mute,
         pic3:mute,
        background:"rgba(0, 0, 0, 0.5)"
    },
    {
        id:3,
        name:"sufian",
        pic:sampleImg2,
        pic1:pak,
        pic2:mute,
         pic3:unmute,
        background:"rgba(0, 0, 0, 0.5)"
    },
    {
        id:4,
        name:"sufian",
        pic:sampleImg1,
        pic1:pak,
        pic2:mute,
         pic3:mute,
        background:"rgba(0, 0, 0, 0.5)"
    },
    {
        id:5,
        name:"sufian",
        pic:'',
        pic1:pak,
        pic2:mute,
         pic3:unmute,
        background:"rgba(0, 0, 0, 0.5)"
    },
    {
        id:6,
        name:"sufian",
        pic:sampleImg1,
        pic1:pak,
        pic2:mute,
         pic3:mute,
        background:"rgba(0, 0, 0, 0.5)"
    },
    {
        id:7,
        name:"sufian",
        pic:sampleImg2,
        pic1:pak,
        pic2:mute,
         pic3:unmute,
        background:"rgba(0, 0, 0, 0.5)"
    },
    {
        id:8,
        name:"sufian",
        pic:sampleImg1,
        pic1:pak,
        pic2:mute,
         pic3:unmute,
        background:"rgba(0, 0, 0, 0.5)"
    }
]


  return (
    <>
    
    <div className="row mt-1  ">

{
    groupCallData && groupCallData.map((item)=>{

return(

<div className="col-4 px-4 my-1 " style={{height:"22vh"}}>

{/* <div className='bg-danger' style={{backgroundImage: `url(${groupCallData[0].pic23 }) `, backgroundRepeat:"no-repeat" , backgroundSize:"100%" , height:"40vh"}} > */}

<div className='position-relative ' style={{ borderRadius:"10px 10px 0px 0px", backgroundImage: `url(${item.pic? item.pic :wait }) `, backgroundRepeat:"no-repeat" , backgroundSize:"cover", height:"100%", width:"100%"}}>

<div className="row  d-flex align-items-end justify-content-end pr-3 pl-2 " style={{height:"22vh", paddingBottom:"1%"}}>

<div className="col-9 d-flex align-items-center"  >

<span className=' px-2 text-light' style={{ zIndex:"100", letterSpacing: "0.02em",   border: "1.5px solid #D6A15E", background: `${item.background}`, borderRadius:"20px", fontSize:"0.9vw", fontWeight:"600"}}> <img src={item.pic1} alt="" /> {item.name}</span>
    
</div>

<div className="col-3  d-flex justify-content-start " >

<img  style={{width:"1.5vw", marginLeft:"22%", zIndex:"100"}} src={item.pic3} alt="" />

</div>

</div>

</div>

<div className='group-call-card-background' style={{height:"30px" ,backgroundImage: "linear-gradient(180deg, transparent, rgba(0,0,0,0.7))", position:"absolute" ,left:"50%", top:"89%", transform:"translate(-50%, -50%)"}}>
{/* <p>he</p> */}
</div>
</div>

)

    })
}





    </div>
    
    </>
  )
}

export default WaitingGroupCall